import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeComponent} from "./home/home.component";
import {LoginComponent} from "./login/login.component";
import {SubscriptionsComponent} from "./subscriptions/subscriptions.component";
import {ProfileComponent} from "./profile/profile.component";
import {PrivacyDocumentationComponent} from "./privacy-documentation/privacy-documentation.component";
import { DashboardComponent } from './dashboard/dashboard.component';
import { PrivacyAboutComponent } from './privacy-about/privacy-about.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import {MainComponent} from "./main/main.component";
import {EmailsMonitoringComponent} from "./emails-monitoring/emails-monitoring.component";
import {BlogComponent} from "./blog/blog.component";
import {BlogInfoComponent} from "./blog-info/blog-info.component";
import {PricingComponent} from "./pricing/pricing.component";
import {LandingBuyNowComponent} from "./landing-buy-now/landing-buy-now.component";
import {LangingBuyNowGybComponent} from "./langing-buy-now-gyb/langing-buy-now-gyb.component";
import {FaqComponent} from "./faq/faq.component";
import {BuyNowLongTermHiComponent} from "./buy-now-long-term-hi/buy-now-long-term-hi.component";
import {BuyNowLongTermComponent} from "./buy-now-long-term/buy-now-long-term.component";

const routes: Routes = [
  {path: '', component: MainComponent},
  {path: 'dashboard', component: HomeComponent},
  {path: 'buy-now', component: LandingBuyNowComponent},
  {path: 'buy-now-gyb', component: LangingBuyNowGybComponent},
  {path: 'buy-now-long-term', component: BuyNowLongTermComponent},
  {path: 'buy-now-long-term-hi', component: BuyNowLongTermHiComponent},
  {path: 'faq', component: FaqComponent},
  {path: 'login', component: LoginComponent},
  {path: 'pricing', component: PricingComponent},
  {path: 'profile', component: ProfileComponent},
  {path: 'blog', component: BlogComponent},
  {path: 'blog/info/:post_url', component: BlogInfoComponent},
  {path: 'subscriptions', component: SubscriptionsComponent},
  {path: 'emails/monitoring', component: EmailsMonitoringComponent},
  {path: 'your_rights_under_privacy_laws', component: PrivacyDocumentationComponent},
  {path: 'why_data_brokers_have_your_info', component: PrivacyAboutComponent},
  {path: 'terms_of_use', component: TermsOfUseComponent},
  {path: 'privacy_policy', component: PrivacyPolicyComponent},
  {path: 'cookie_policy', component: CookiePolicyComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
